const endpoint = {
  getList: "/tms/leaves-management/annual-leaves/priority-leave",
  create: "/tms/leaves-management/annual-leaves/priority-leave/create",
  update: "/tms/leaves-management/annual-leaves/priority-leave/update",
  delete: "/tms/leaves-management/annual-leaves/priority-leave/delete",
  history: "/tms/leaves-management/annual-leaves/priority-leave/history",
  import: "/tms/leaves-management/annual-leaves/priority-leave/import",
  getTemplate: "/tms/leaves-management/annual-leaves/priority-leave/template",
};

import http from "../../helpers/httpInterceptor";
import { downloadFile } from "@/utils";

const state = () => ({
  bonusLeaveList: [],
  createBonusLeave: [],
  updateBonusLeave: [],
  historyBonusLeaveList: [],
});

const mutations = {
  //#region bonus leave state
  BONUS_LEAVE_LIST(state, data) {
    state.bonusLeaveList = data;
  },
  CREATE_BONUS_LEAVE(state, data) {
    state.createBonusLeave = data;
  },
  UPDATE_BONUS_LEAVE(state, data) {
    state.updateBonusLeave = data;
  },
  HISTORY_BONUS_LEAVE_LIST(state, data) {
    state.historyBonusLeaveList = data;
  },
  //#endregion
};

const actions = {
  getBonusLeaveList({ commit }, url = "") {
    return http
      .get(endpoint.getList + url)
      .then((res) => {
        commit("BONUS_LEAVE_LIST", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  createBonusLeave({ commit }, payload) {
    return http
      .post(endpoint.create, payload)
      .then((res) => {
        commit("CREATE_BONUS_LEAVE", res);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateBonusLeave({ commit }, payload) {
    return http
      .put(endpoint.update, payload)
      .then((res) => {
        commit("UPDATE_BONUS_LEAVE", res);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },

  deleteBonusLeave(_, params) {
    return http
      .delete(endpoint.delete + `/${params}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  historyBonusLeaveList({ commit }, url = "") {
    return http
      .get(endpoint.history + url)
      .then((res) => {
        let data = res.data.data;
        if (data.length) {
          data.forEach((v) => {
            v.new_record["employee"] = v.employee;
          });
        }
        commit("HISTORY_BONUS_LEAVE_LIST", data);
        return data;
      })
      .catch((error) => {
        throw error;
      });
  },

  importFile(_, payload) {
    const formData = new FormData();
    formData.append("files", payload[0]);
    return http
      .post(endpoint.import, formData, { responseType: "blob" })
      .then((res) => {
        if (res.headers.code != 200) {
          const fileName = res.headers.fileName ?? "BonusLeaveResult.xlsx";
          downloadFile(res.data, fileName);
        }

        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
  downloadTemplate() {
    return http
      .get(endpoint.getTemplate, { responseType: "blob" })
      .then((res) => {
        const fileName = res.headers.fileName ?? res.headers.filename ?? "Template.xlsx";
        downloadFile(res.data, fileName);
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
